import { t } from '../i18n/index.js';
import { getEvent } from '../model.js';
import { closeAllSheets, nav, toast } from '../ui.js';
import { completeFlow, openEventSheet } from '../views/calendar.js';
import { openRecap } from '../views/recap.js';

/* Notification taps open /?open=<lesson id>&do=prep|soon|after|agenda.
   Captured at boot, run once the data is loaded (or straight away when the app is already open). */
let pending=null;
export function captureDeepLink(){
  try{
    const q=new URLSearchParams(location.search);const open=q.get('open'),act=q.get('do');
    if(!open&&!act)return;
    pending={open,act};q.delete('open');q.delete('do');
    const rest=q.toString();history.replaceState(null,'',location.pathname+(rest?'?'+rest:'')+location.hash);
  }catch(e){}
}
export function openFromUrl(url){
  try{const q=new URL(url,location.origin).searchParams;pending={open:q.get('open'),act:q.get('do')};runDeepLink()}catch(e){}
}
export function runDeepLink(){
  if(!pending)return;
  const{open,act}=pending;pending=null;
  closeAllSheets();nav('home');
  if(!open)return;
  const evt=getEvent(open);
  if(!evt){toast(t('dl.missing'));return}
  setTimeout(()=>{
    if(act==='after'&&evt.status==='planned')completeFlow(evt);
    else if(act==='after'&&evt.status==='done'&&!evt.virtual)openRecap(evt.id);
    else openEventSheet(evt);
  },80);
}
